export default __webpack_public_path__ + "static/media/CS_132.2a33df62.png";